import './AppointmentList.scss';
import { getDateInLocalTZ, useTranslation } from '../../utils';
import { useData, useHandlers } from './hooks';

type TAppointmentListProps = {
  expertId?: number;
};

const AppointmentList = ({ expertId }: TAppointmentListProps) => {
  const { apptList } = useData();
  const filteredList = expertId ? apptList?.filter((appt) => appt.serviceProviderId === expertId) : apptList;
  const { onApptClick } = useHandlers({ apptList: filteredList });
  const { t } = useTranslation();

  const title = t('Dashboard (client).Text_field_coming_appointments').split('\n')[0];

  if (!filteredList?.length) {
    if (expertId) return <></>;

    return (
      <div className='appointments-empty'>
        <svg width='84' height='84' viewBox='0 0 84 84' fill='none'>
          <rect x='14' y='16' width='56' height='52' rx='10' fill='#F3F2FA' />
          <rect x='14' y='16' width='56' height='16' rx='10' fill='#EDEBF7' />
          <rect x='27' y='9' width='4' height='12' rx='2' fill='#C9C4E8' />
          <rect x='53' y='9' width='4' height='12' rx='2' fill='#C9C4E8' />
          <circle cx='42' cy='47' r='16' fill='#FFFFFF' stroke='#D8D4F0' strokeWidth='2' />
          <path
            d='M35 49c1.5 2.5 4 4 7 4s5.5-1.5 7-4'
            stroke='#8B84C9'
            strokeWidth='2.2'
            strokeLinecap='round'
          />
          <circle cx='37' cy='43' r='1.8' fill='#8B84C9' />
          <circle cx='47' cy='43' r='1.8' fill='#8B84C9' />
          <path d='M60 22l3 3M63 22l-3 3' stroke='#C9C4E8' strokeWidth='2' strokeLinecap='round' />
          <path d='M20 22l3 3M23 22l-3 3' stroke='#C9C4E8' strokeWidth='2' strokeLinecap='round' />
        </svg>
        <p className='appointments-empty__title'>{t('My appointments (client).Text_field')}</p>
      </div>
    );
  }

  return (
    <>
      <h3 className='sectionTitle'>
        <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
          <rect x='3' y='4' width='18' height='18' rx='2' />
          <path d='M16 2v4M8 2v4M3 10h18' strokeLinecap='round' strokeLinejoin='round' />
        </svg>
        {title}
      </h3>
      <div className='list'>
        {filteredList.map((appt, i) => {
          const { localDate, localTime } = getDateInLocalTZ(appt.startDate);

          return (
            <div key={i} data-appt-id={appt.appointmentId} className='appointment' onClick={onApptClick}>
              <div className='card-header'>
                <div className='datetime'>
                  <span className='date'>{localDate}</span>
                  <span className='time'>{localTime}</span>
                </div>
                <span className={`status-tag ${appt.type}`}>
                  {t(`Confirmation.Text_${appt.type.toLocaleLowerCase()}`)}
                </span>
              </div>

              <div className='divider' />

              <div className='info-grid'>
                <div className='info-row'>
                  <span className='label'>
                    <svg width='13' height='13' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
                      <path d='M4 4h16v16H4z' strokeLinecap='round' strokeLinejoin='round' />
                      <path d='M4 9h16' strokeLinecap='round' strokeLinejoin='round' />
                    </svg>
                    {t('Confirmation.Text_service')}
                  </span>
                  <span className='value'>{appt.expertFacility.facility}</span>
                </div>

                {!expertId && (
                  <div className='info-row'>
                    <span className='label'>
                      <svg width='13' height='13' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
                        <circle cx='12' cy='8' r='4' />
                        <path d='M4 21c0-4 3.5-7 8-7s8 3 8 7' strokeLinecap='round' strokeLinejoin='round' />
                      </svg>
                      {t('New appointment (client).Text_expert')}
                    </span>
                    <span className='value'>{appt.serviceProviderName}</span>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default AppointmentList;